<template>
  <v-container fluid grid-list-md>
    <v-tabs grow v-model="tab">
      <!-- <v-tabs-slider color="primary"></v-tabs-slider> -->

      <v-tab>
        <v-icon style="margin-right:10px">medical_services</v-icon>
        {{ $t("views.guides.health_reasonable_&_customary_guides") }}
      </v-tab>
      <v-tab>
        <v-icon style="margin-right:10px">mdi-tooth</v-icon>
        {{ $t("views.guides.dental_fee_guides") }}
      </v-tab>
      <v-tab>
        <v-icon style="margin-right:10px">search</v-icon>
        {{ $t("views.guides.search_per_benefit") }}
      </v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <health-reasonable-customary-guides />
        </v-tab-item>
        <v-tab-item>
          <dental-fee-guides />
        </v-tab-item>
        <v-tab-item>
          <search-per-benefit />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <error-handler :error="error"></error-handler>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import HealthReasonableCustomaryGuides from "../components/Guides/HealthReasonableCustomaryGuides.vue";
import DentalFeeGuides from "../components/Guides/DentalFeeGuides.vue";
import SearchPerBenefit from "../components/Guides/SearchPerBenefit.vue";

export default {
  components: {
    ErrorHandler,
    HealthReasonableCustomaryGuides,
    DentalFeeGuides,
    SearchPerBenefit,
  },
  data() {
    return {
      tab: null,
      error: null,
    };
  },
  computed: {
    ...mapGetters("common", { settings: "settings" }),
    ...mapGetters("common", ["language"]),
  },
  methods: {
    ...mapActions("plansMembers", ["getCoverageByDate", "getPlan"]),
    ...mapActions("data", ["fetchFile"]),
  },
};
</script>
